function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.71 4.118h-2.4L4.493.465a.444.444 0 00-.33-.446.465.465 0 00-.527.203L.062 6.157a.43.43 0 000 .444.464.464 0 00.398.221l2.384-.005-.504 4.425a.443.443 0 00.318.47.471.471 0 00.542-.205l3.911-6.73a.428.428 0 00-.004-.44.464.464 0 00-.397-.219z",
  fill: "#9A9FA7",
  fillRule: "evenodd"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 12"
  }, props), _ref);
};

export default SvgComponent;